import { render, staticRenderFns } from "./ScalesSettings.vue?vue&type=template&id=ad52daf6&scoped=true"
import script from "./ScalesSettings.vue?vue&type=script&lang=js"
export * from "./ScalesSettings.vue?vue&type=script&lang=js"
import style0 from "./ScalesSettings.vue?vue&type=style&index=0&id=ad52daf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad52daf6",
  null
  
)

export default component.exports